// Parsing aman untuk JSON yang datang sebagai string dari API atau storage.
//
// `JSON.parse` polos melempar pada input rusak, dan penjagaan `|| "{}"` hanya
// menutup null dan string kosong. Ia juga mengembalikan `null` untuk literal
// `"null"`, yang langsung melempar lagi begitu pemanggilnya mengindeks hasilnya.
// Fungsi ini menjawab dengan fallback alih-alih melempar, sehingga nilai rusak
// merusak satu layar, bukan menjatuhkan aplikasi.
//
// Port dari mobile-user/src/utils/json.js.
export const parseJsonObject = (value, fallback = {}) => {
  // Nilai yang sudah terparsing lewat begitu saja, jadi pemanggil tidak perlu
  // menebak apakah field-nya kembali sebagai string atau objek.
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value;
  }
  if (typeof value !== "string" || !value.trim()) {
    return fallback;
  }
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : fallback;
  } catch (error) {
    return fallback;
  }
};
